var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { safeAssign } from "./safe-assign";
export class TimeLogEventDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], TimeLogEventDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], TimeLogEventDTO.prototype, "action", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], TimeLogEventDTO.prototype, "source", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], TimeLogEventDTO.prototype, "deviceId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], TimeLogEventDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], TimeLogEventDTO.prototype, "positionId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], TimeLogEventDTO.prototype, "timeEntryId", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    __metadata("design:type", Date)
], TimeLogEventDTO.prototype, "time", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], TimeLogEventDTO.prototype, "status", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], TimeLogEventDTO.prototype, "rejectedReason", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], TimeLogEventDTO.prototype, "location", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], TimeLogEventDTO.prototype, "image", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], TimeLogEventDTO.prototype, "comment", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], TimeLogEventDTO.prototype, "meals", void 0);
//# sourceMappingURL=time-log-event.dto.js.map